<script setup lang="ts">
type TProps = {
  titleAriaLabel: string
  title: string
  show: boolean
}

const props = defineProps<TProps>()

const { show } = toRefs(props)

type TEmits = {
  'toggle:show': []
}

const emits = defineEmits<TEmits>()

const togglePanel = () => {
  emits('toggle:show')
}
</script>

<template>
  <div
    class="inline-flex flex-col justify-start items-start gap-2 md:gap-4 w-full max-w-full border-b last:border-none border-trail-border-normal"
  >
    <button
      type="button"
      :aria-controls="`accordion-panel-${props.titleAriaLabel}`"
      class="inline-flex justify-between text-left items-start w-full max-w-full gap-4 py-2 md:py-6 text-trail-title3"
      @click.prevent="togglePanel"
    >
      <div
        class="inline-flex justify-start items-center gap-2 text-trail-title3 text-trail-text-title-normal"
      >
        <slot name="title">
          <h3>{{ props.title }}</h3>
        </slot>
      </div>

      <div class="inline-flex justify-center items-center gap-2">
        <NuxtIcon
          name="heroicons:chevron-down"
          size="1.5rem"
          :class="[
            'will-change-transform transition-transform duration-200 ease-in-out',
            { 'rotate-180': show },
          ]"
        />
      </div>
    </button>

    <TransitionExpand
      :duration="{ enter: 600, leave: 100 }"
      easing="linear(0, 0.003 0.4%, 0.01 0.8%, 0.024 1.3%, 0.042 1.8%, 0.101 3.1%, 0.293 6.9%, 0.393 9.1%, 0.446 10.4%, 0.498 11.8%, 0.545 13.2%, 0.591 14.7%, 0.635 16.3%, 0.676 18%, 0.713 19.7%, 0.748 21.5%, 0.779 23.4%, 0.809 25.4%, 0.835 27.5%, 0.859 29.7%, 0.88 32%, 0.899 34.4%, 0.915 36.9%, 0.93 39.6%, 0.943 42.4%, 0.954 45.5%, 0.964 48.8%, 0.972 52.4%, 0.984 60.3%, 0.992 70%, 0.997 82.4%, 1)"
      tag="div"
      appear
    >
      <div v-show="show" class="w-full max-w-full">
        <slot />
      </div>
    </TransitionExpand>
  </div>
</template>
